export const convertObjectToArray = (object: any) =>
  Object.keys(object)
    .map((item) => object[item])
    .filter((item) => !!item);

export const convertObjectToArrayAndSort = (object: any) =>
  Object.keys(object)
    .sort((a, b) => {
      const aMatch = a.match(/\d+$/);
      const bMatch = b.match(/\d+$/);
      if (aMatch && bMatch) {
        return parseInt(aMatch[0]) - parseInt(bMatch[0]);
      }

      return a.localeCompare(b);
    })
    .map((item) => object[item])
    .filter((item) => !!item);

export const convertObjectToArrayWithKeyAsId = (object: any) =>
  Object.keys(object)
    .map((item) => ({ ...object[item], id: item }))
    .filter((item) => !!item);
